var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "header",
    { staticClass: "top-bar main-padding" },
    [
      _c(
        "div",
        {
          staticClass: "d-flex align-items-center gap-1 flex-grow-1 flex-wrap",
        },
        [
          _vm.isSuperadminLoggedSchool && !_vm.isTeacher
            ? _c("div", {}, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary btn-sm",
                    on: { click: _vm.backToSuperadminPanel },
                  },
                  [
                    _c("i", {
                      staticClass:
                        "fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400",
                    }),
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.Lang.get("messages.back_to_superadmin_panel")
                        ) +
                        "\n      "
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isTeacher && _vm.isSystemAdmin
            ? _c(
                "div",
                { staticClass: "dropdown school-switcher-navbar mx-2" },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn modern-lang-btn-navbar d-flex align-items-center gap-2 dropdown-toggle reset-view-btn",
                      attrs: {
                        type: "button",
                        title: _vm.Lang.get("messages.select_school"),
                      },
                      on: { click: _vm.toggleSchoolSelector },
                    },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "lang-text d-none d-md-inline" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.user.school
                                ? _vm.user.school.name
                                : _vm.Lang.get("messages.select_school")
                            )
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.showSchoolSelector
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "dropdown-menu show modern-lang-dropdown",
                          staticStyle: {
                            left: "auto",
                            right: "auto",
                            "max-height": "400px",
                            "overflow-y": "auto",
                            width: "250px",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "dropdown-header px-3 py-2" },
                            [
                              _c("small", { staticClass: "text-muted" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.Lang.get(
                                      "messages.available_schools"
                                    ) || "المدارس المتاحة"
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "dropdown-item text-primary font-weight-bold border-bottom mb-2",
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.backToSuperadminPanel.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "fas fa-home mr-2" }),
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.Lang.get(
                                      "messages.back_to_superadmin_panel"
                                    )
                                  ) +
                                  "\n        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.schools, function (school) {
                            return _c(
                              "a",
                              {
                                key: school.id,
                                staticClass:
                                  "dropdown-item d-flex align-items-center justify-content-between",
                                class: {
                                  active:
                                    _vm.user.school &&
                                    _vm.user.school.id === school.id,
                                },
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.selectSchool(school)
                                  },
                                },
                              },
                              [
                                _c("span", [_vm._v(_vm._s(school.name))]),
                                _vm._v(" "),
                                _vm.user.school &&
                                _vm.user.school.id === school.id
                                  ? _c("i", { staticClass: "fas fa-check" })
                                  : _vm._e(),
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _vm.schools.length === 0
                            ? _c(
                                "div",
                                { staticClass: "text-center p-3 text-muted" },
                                [
                                  _c("i", {
                                    staticClass: "fas fa-spinner fa-spin mr-2",
                                  }),
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        _vm.Lang.get("messages.loading") ||
                                          "جاري التحميل..."
                                      ) +
                                      "\n        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                ]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "d-flex justify-content-between align-items-center mx-content",
        },
        [
          _c("div", { staticClass: "d-flex align-items-center gap-2" }, [
            _vm.isHodLoggedAsTeacher
              ? _c("div", { staticClass: "back_home" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-border-secondary fs-12 back_btn",
                      on: { click: _vm.backToHodDashboard },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.Lang.get("messages.back_to_main")) +
                          "\n        "
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isTeacher
              ? _c("div", { staticClass: "dropdown user-controls" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "notifications-button header_icon dropdown-toggle",
                      attrs: {
                        type: "button",
                        id: "dropdownMenuButton2",
                        "data-toggle": "dropdown",
                        "aria-haspopup": "true",
                        "aria-expanded": "false",
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "icon-lg",
                        attrs: {
                          src: "/assets/front_end/portals/images/icons/chat.svg",
                          alt: "Chat",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "indicator",
                          attrs: { "aria-hidden": "true" },
                        },
                        [_vm._v(_vm._s(_vm.notifications.length))]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isTeacher
                    ? _c(
                        "div",
                        {
                          staticClass: "dropdown-menu chat",
                          attrs: { "aria-labelledby": "dropdownMenuButton2" },
                        },
                        [
                          _c(
                            "h5",
                            { staticClass: "dropdown_header custom-h" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "relative-indicator",
                                  attrs: { "aria-hidden": "true" },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.notifications.length)
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.Lang.get("messages.chats"))),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.notifications.length > 0
                            ? _c(
                                "ul",
                                { staticClass: "custom-ul" },
                                [
                                  _vm._l(
                                    _vm.notifications,
                                    function (notification, index) {
                                      return _c(
                                        "li",
                                        {
                                          key: index,
                                          staticClass:
                                            "d-flex gap-2 align-items-start",
                                        },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              staticClass: "dropdown-item",
                                              attrs: {
                                                to: {
                                                  name: "teacher-messenger",
                                                  params: {
                                                    class_id: _vm._.get(
                                                      _vm.getParentClass(
                                                        notification.sender
                                                          ?.classes
                                                      ),
                                                      "id"
                                                    ),
                                                    user_id:
                                                      notification.sender?.id,
                                                  },
                                                },
                                              },
                                            },
                                            [
                                              _c("img", {
                                                staticClass: "chat_img",
                                                attrs: {
                                                  src: "/assets/front_end/portals/images/user.svg",
                                                  alt: "User",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "w-100" },
                                                [
                                                  _c(
                                                    "h6",
                                                    { staticClass: "custom-h" },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm._.get(
                                                              _vm.getParentClass(
                                                                notification
                                                                  .sender
                                                                  ?.classes
                                                              ),
                                                              "name"
                                                            )
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "h6",
                                                    {
                                                      staticClass:
                                                        "fs-12 gray-color custom-h mt-2 d-flex gap-1 justify-content-between",
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            notification.message
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  _vm._v(" "),
                                  _vm.isTeacher
                                    ? _c(
                                        "li",
                                        {
                                          staticClass:
                                            "d-flex gap-2 align-items-start",
                                        },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              staticClass: "dropdown-item",
                                              attrs: {
                                                to: {
                                                  name: "teacher-messenger",
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.Lang.get(
                                                      "messages.open_messenger"
                                                    )
                                                  ) +
                                                  "\n              "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                2
                              )
                            : _c(
                                "div",
                                { staticClass: "text-center p-4 text-muted" },
                                [
                                  _vm._m(1),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "m-0 fs-12" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.Lang.get(
                                            "messages.no_notifications"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm.isTeacher
                                    ? _c(
                                        "div",
                                        { staticClass: "mt-2" },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              staticClass:
                                                "btn btn-sm btn-light",
                                              attrs: {
                                                to: {
                                                  name: "teacher-messenger",
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.Lang.get(
                                                      "messages.open_messenger"
                                                    )
                                                  ) +
                                                  "\n              "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              ),
                        ]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.isSuperadmin
              ? _c("div", { staticClass: "dropdown" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "notifications-button header_icon dropdown-toggle",
                      attrs: {
                        type: "button",
                        id: "dropdownMenuButton4",
                        "data-toggle": "dropdown",
                        "aria-haspopup": "true",
                        "aria-expanded": "false",
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "icon-lg",
                        attrs: {
                          src: "/assets/front_end/portals/images/icons/Bell.svg",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "indicator",
                          attrs: { "aria-hidden": "true" },
                        },
                        [_vm._v(_vm._s(_vm.mongoNotificationsCount))]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dropdown-menu notification",
                      attrs: { "aria-labelledby": "dropdownMenuButton4" },
                    },
                    [
                      _c("h5", { staticClass: "dropdown_header custom-h" }, [
                        _c(
                          "span",
                          {
                            staticClass: "relative-indicator",
                            attrs: { "aria-hidden": "true" },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.mongoNotificationsCount)
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.Lang.get("messages.notifications_title"))
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.mongoNotifications.length > 0
                        ? _c(
                            "ul",
                            { staticClass: "custom-ul" },
                            _vm._l(
                              _vm.mongoNotifications,
                              function (notification, index) {
                                return _c(
                                  "li",
                                  {
                                    key: index,
                                    staticClass:
                                      "d-flex gap-2 align-items-start",
                                    on: {
                                      click: function ($event) {
                                        return _vm.markNotificationAsRead(
                                          notification.id,
                                          notification.link
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "notification_img",
                                      attrs: {
                                        src: "/assets/front_end/portals/images/blue_logo.svg",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("div", [
                                      _c(
                                        "h6",
                                        {
                                          staticClass: "custom-h",
                                          class: {
                                            "fw-bold": !notification.is_read,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(notification.title) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "h6",
                                        {
                                          staticClass:
                                            "fs-12 gray-color custom-h mt-2",
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(notification.body) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "h6",
                                        {
                                          staticClass:
                                            "fs-12 gray-color custom-h mt-3 d-flex gap-1",
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "far fa-clock",
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(notification.date)),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                  ]
                                )
                              }
                            ),
                            0
                          )
                        : _c(
                            "div",
                            { staticClass: "text-center p-4 text-muted" },
                            [
                              _vm._m(2),
                              _vm._v(" "),
                              _c("p", { staticClass: "m-0 fs-12" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.Lang.get("messages.no_notifications")
                                    ) +
                                    "\n            "
                                ),
                              ]),
                            ]
                          ),
                      _vm._v(" "),
                      _c("hr", { staticClass: "my-2" }),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          staticClass:
                            "custom-anc secondary text-center d-block",
                          attrs: { to: { name: "show-notifications" } },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.Lang.get("website.show_all")) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.isTeacher && !_vm.isHod
              ? _c("div", { staticClass: "dropdown" }, [
                  !_vm.isTeacher || !_vm.isHodLoggedAsTeacher
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "explore-button header_icon dropdown-toggle",
                          attrs: {
                            type: "button",
                            id: "dropdownMenuButton",
                            "data-toggle": "dropdown",
                            "aria-haspopup": "true",
                            "aria-expanded": "false",
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "icon-lg",
                            attrs: {
                              src: "/assets/front_end/assets/images/heart.svg",
                              alt: "Favorites",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "indicator",
                              attrs: { "aria-hidden": "true" },
                            },
                            [_vm._v(_vm._s(_vm.fav_list.length))]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isHodLoggedAsTeacher
                    ? _c(
                        "ul",
                        {
                          staticClass: "dropdown-menu custom-ul",
                          attrs: { "aria-labelledby": "dropdownMenuButton" },
                        },
                        _vm._l(_vm.fav_list, function (item, index) {
                          return _c(
                            "li",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                },
                              },
                            },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: { path: item.path, query: item.query },
                                  },
                                },
                                [
                                  _c(
                                    "h6",
                                    { staticClass: "third-color custom-h" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.Lang.get(
                                              `messages.sidebar.${item.label}`
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("img", {
                                staticStyle: { cursor: "pointer" },
                                attrs: {
                                  src: "/assets/front_end/assets/images/close-circle.svg",
                                  alt: "Remove",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeFromFav(item)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dropdown lang-switcher-navbar" }, [
            _c(
              "button",
              {
                staticClass:
                  "btn modern-lang-btn-navbar d-flex align-items-center gap-2 dropdown-toggle",
                attrs: {
                  type: "button",
                  id: "langDropdownButton",
                  "data-toggle": "dropdown",
                  "aria-haspopup": "true",
                  "aria-expanded": "false",
                },
              },
              [
                _vm._m(3),
                _vm._v(" "),
                _c("span", { staticClass: "lang-text d-none d-md-inline" }, [
                  _vm._v(_vm._s(_vm.currentLanguageNativeName)),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "dropdown-menu dropdown-menu-right modern-lang-dropdown",
                attrs: { "aria-labelledby": "langDropdownButton" },
              },
              [
                _c("div", { staticClass: "dropdown-header px-3 py-2" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(
                      _vm._s(
                        _vm.Lang.get("messages.selectLanguage") || "اختر اللغة"
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _vm._l(_vm.activeLanguages, function (lang) {
                  return _c(
                    "a",
                    {
                      key: lang.code,
                      staticClass:
                        "dropdown-item d-flex align-items-center justify-content-between",
                      class: { active: _vm.currentLocale === lang.code },
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.handleLanguageChange(lang.code)
                        },
                      },
                    },
                    [
                      _c("span", [_vm._v(_vm._s(lang.native_name))]),
                      _vm._v(" "),
                      _vm.currentLocale === lang.code
                        ? _c("i", { staticClass: "fas fa-check text-success" })
                        : _vm._e(),
                    ]
                  )
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dropdown user-profile-navbar" }, [
            _c(
              "button",
              {
                staticClass:
                  "btn modern-lang-btn-navbar d-flex align-items-center gap-2 dropdown-toggle",
                attrs: {
                  type: "button",
                  id: "dropdownMenuButton3",
                  "data-toggle": "dropdown",
                  "aria-haspopup": "true",
                  "aria-expanded": "false",
                },
              },
              [
                _vm._m(4),
                _vm._v(" "),
                _c("span", { staticClass: "lang-text d-none d-md-inline" }, [
                  _vm._v(_vm._s(_vm.user.name)),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "dropdown-menu dropdown-menu-right modern-lang-dropdown",
                attrs: { "aria-labelledby": "dropdownMenuButton3" },
              },
              [
                _c("div", { staticClass: "dropdown-header px-3 py-2" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.Lang.get("messages.profile"))),
                  ]),
                ]),
                _vm._v(" "),
                _vm.isSystemAdmin
                  ? _c(
                      "a",
                      {
                        staticClass:
                          "dropdown-item d-flex align-items-center justify-content-between",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.$router.push(
                              "/super-admin/general-settings"
                            )
                          },
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.Lang.get("messages.general_settings"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "fas fa-cogs text-muted",
                          staticStyle: { "font-size": "0.8rem" },
                        }),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isTeacher
                  ? _c(
                      "a",
                      {
                        staticClass:
                          "dropdown-item d-flex align-items-center justify-content-between",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openProfileModal()
                          },
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.Lang.get("messages.profile"))),
                        ]),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "fas fa-user-circle text-muted",
                          staticStyle: { "font-size": "0.8rem" },
                        }),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "dropdown-divider mx-2 my-1" }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass:
                      "dropdown-item d-flex align-items-center justify-content-between",
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.logout.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.Lang.get("messages.logout"))),
                    ]),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "fas fa-sign-out-alt text-danger",
                      staticStyle: { "font-size": "0.8rem" },
                    }),
                  ]
                ),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("modal", {
        ref: "profileModal",
        attrs: { target: "p-profile-modal" },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c("profileModal", {
                  attrs: { request: _vm.user },
                  on: { updated: _vm.onUpdate },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "lang-icon-wrapper" }, [
      _c("i", { staticClass: "fas fa-university" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mb-2" }, [
      _c("i", { staticClass: "far fa-bell-slash fa-2x text-gray-400" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mb-2" }, [
      _c("i", { staticClass: "far fa-bell-slash fa-2x text-gray-400" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "lang-icon-wrapper" }, [
      _c("i", { staticClass: "fas fa-globe" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "lang-icon-wrapper" }, [
      _c("i", { staticClass: "fas fa-user" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }